import windowLoad from '../events/window-load'

export default (function() {
  'use strict';

  function createLine(index, fragment) {
    var line = document.createElement('div')
    line.classList.add('c-lbl-container__line')

    var lineContent = document.createElement('div')
    lineContent.classList.add('c-lbl-container__content')
    lineContent.classList.add(`masked-copy--${ index }`)
    line.appendChild(lineContent)

    fragment.appendChild(line)
    return lineContent;
  }

  function updateLines(visibleElement, referenceElement) {

    visibleElement.classList.add('u-display-none')
    let referenceElementRect = referenceElement.getBoundingClientRect();
    var clonedVisibleElement = visibleElement.cloneNode()
    var fragment = document.createDocumentFragment()
    var lines = [createLine(1, fragment)];
    var currentTop = null;

    Array.from(referenceElement.querySelectorAll('.word')).forEach((word, i) => {
      let wordRect = word.getBoundingClientRect()
      if (currentTop === null) {
        currentTop = wordRect.top;
      }

      if (wordRect.top > currentTop) {
        currentTop = wordRect.top;
        lines.push(createLine(lines.length + 1, fragment));
      }

      var newWordNode = word.cloneNode(true);
      newWordNode.innerHTML = newWordNode.innerHTML.replace(/\s/, '')

      let line = lines[lines.length - 1]
      line.appendChild(newWordNode)
      line.appendChild(document.createTextNode(`\u00A0`))
    })

    lines.forEach((line) => clonedVisibleElement.appendChild(line.parentNode))
    visibleElement.parentNode.replaceChild(clonedVisibleElement, visibleElement);

    clonedVisibleElement.classList.remove('u-display-none')
  }

  var resizeHandler;

  function init() {
    const textWrappers = Array.from(document.querySelectorAll('.line-by-line-block'))

    if (resizeHandler) {
      window.removeEventListener('resize', resizeHandler)
    }

    resizeHandler = function() {
      textWrappers.forEach((textWrapper) => {
        const visibleText = textWrapper.querySelector('.text')
        const textReference = textWrapper.querySelector('.text-reference')
        updateLines(visibleText, textReference)
      })
    }

    window.addEventListener('resize', resizeHandler)

    windowLoad()
      .then(() => {
        textWrappers.forEach((textWrapper) => {
          const visibleText = textWrapper.querySelector('.text')
          const textReference = textWrapper.querySelector('.text-reference')

          let childNodes = Array.from(textReference.childNodes)
          childNodes.forEach((child) => {

            let lastWordElem = child
            let replacedFirst = false
            let hasHighlight = child.nodeType == 1
            child.textContent.trim().split(/\s+/).forEach((word) => {

              let wordElem = document.createElement('span')
              wordElem.classList.add('word')
              if (word.indexOf('-') !== -1) {
                wordElem.classList.add('word--no-break')
              }
              if (hasHighlight) {
                wordElem.classList.add('word--highlight')
              }
              wordElem.textContent = word + ' ';

              if (!replacedFirst) {
                lastWordElem.parentNode.replaceChild(wordElem, lastWordElem)
              } else {
                lastWordElem.parentNode.insertBefore(wordElem, lastWordElem.nextSibling);
              }

              lastWordElem = wordElem
              replacedFirst = true
            })
          })

          updateLines(visibleText, textReference)
        })
      })
  }

  return {
    init: init
  };

})();
